var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.7C0 1.20884 1.17526 0 2.625 0H8.90015C9.5963 0 10.264 0.284463 10.7563 0.790812L13.2311 3.3364C13.7234 3.84275 14 4.5295 14 5.24559V15.3C14 16.7912 12.8248 18 11.375 18H2.625C1.17526 18 0 16.7912 0 15.3V2.7ZM2.625 1.8C2.14176 1.8 1.75 2.20295 1.75 2.7V15.3C1.75 15.7971 2.14176 16.2 2.625 16.2H11.375C11.8583 16.2 12.25 15.7971 12.25 15.3V5.24559C12.25 5.00689 12.1578 4.77797 11.9937 4.60919L9.51886 2.0636C9.35471 1.89482 9.1322 1.8 8.90015 1.8H2.625ZM3.5 7.2C3.5 6.70295 3.89176 6.3 4.375 6.3H9.625C10.1083 6.3 10.5 6.70295 10.5 7.2C10.5 7.69707 10.1083 8.1 9.625 8.1H4.375C3.89176 8.1 3.5 7.69707 3.5 7.2ZM3.5 10.8C3.5 10.3029 3.89176 9.9 4.375 9.9H7.875C8.35826 9.9 8.75 10.3029 8.75 10.8C8.75 11.2971 8.35826 11.7 7.875 11.7H4.375C3.89176 11.7 3.5 11.2971 3.5 10.8Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.e1c1748dab17546694ed9f8d477bce55.svg";
export { ForwardRef as ReactComponent };